import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sm:col-span-full flex flex-col"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = ["name", "id"]
const _hoisted_4 = {
  key: 1,
  class: "sm:col-span-full"
}
const _hoisted_5 = {
  key: 2,
  class: "w-full"
}
const _hoisted_6 = { class: "relative w-full" }
const _hoisted_7 = ["id", "placeholder", "required", "rows", "disabled"]
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "relative z-50" }
const _hoisted_10 = ["id"]
const _hoisted_11 = ["id"]

import { ref, shallowRef, computed, onMounted } from "vue";
import { defineEmits } from "@vue/runtime-core";
import { useStore } from "vuex";
import { MainContainer } from "@/models/MainContainer";
import { Profile } from "@/models/Profile";
import * as dtos from "@/models/dtos";

export default /*@__PURE__*/_defineComponent({
  __name: 'InputTextarea',
  props: {
  model: {
    required: false,
  },
  type: String,
  required: {
    type: Boolean,
    required: false,
    default: false,
  },
  rows: {
    type: Number,
    required: false,
    default: 6,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
  editMode: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const containerByDNS = ref<Profile>(null);
const emit = __emit;
const props = __props;
let model = shallowRef(props.model as dtos.DynamicProperty);
const showingErrorMessage = ref(false);

const showErrorMessage = () => {
  showingErrorMessage.value = true;
};
const hideErrorMessage = () => {
  showingErrorMessage.value = false;
};
function customChange(event: any) {
  emit("change", model.value);
}

onMounted(async () => {
  await store.dispatch("loadContainerTheme");
  try {
    await store.dispatch("loadContainerTheme");
    containerByDNS.value = new Profile(
      new MainContainer(store.getters.publicContainer)
    );
    // isLoaded.value = true;
  } catch (error) {
    console.error("Error loading public container:", error);
  }
});

const themedText = computed(() => store.getters.getContainerThemedText);

return (_ctx: any,_cache: any) => {
  return (props.adminView && props.editMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
          style: _normalizeStyle({color: themedText.value?.detailText}),
          for: _unref(model).label,
          class: "text-sm font-medium text-gray-500"
        }, _toDisplayString(_unref(model).label || "fältet saknar rubrik"), 13, _hoisted_2),
        _withDirectives(_createElementVNode("textarea", {
          onInput: customChange,
          rows: "4",
          name: _unref(model).label,
          id: _unref(model).key,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).data) = $event)),
          class: "mt-1 p-2 block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:py-1.5 sm:text-sm sm:leading-6"
        }, null, 40, _hoisted_3), [
          [_vModelText, _unref(model).data]
        ])
      ]))
    : (props.adminView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("dt", {
            style: _normalizeStyle({color: themedText.value?.detailText}),
            class: "text-sm font-medium text-gray-500"
          }, _toDisplayString(_unref(model).label || "fältet saknar rubrik"), 5),
          _createElementVNode("dd", {
            style: _normalizeStyle({color: themedText.value?.otherText}),
            class: "mt-1 text-sm text-gray-900"
          }, _toDisplayString(_unref(model).data || "Ingen information angiven."), 5)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("label", {
            style: _normalizeStyle({color: themedText.value?.otherText}),
            class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1",
            for: "name"
          }, _toDisplayString(_unref(model).label), 5),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("textarea", {
              onInput: customChange,
              class: "appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 border border-blue-4 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed",
              id: _unref(model).key,
              type: "textarea",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).data) = $event)),
              placeholder: _unref(model).placeholder,
              required: props.required ? true : null,
              rows: props.rows ? props.rows : null,
              disabled: props.disabled ? true : null
            }, null, 40, _hoisted_7), [
              [_vModelText, _unref(model).data]
            ]),
            _createElementVNode("div", {
              id: 'icon-error_' + _unref(model).key,
              class: "hidden absolute top-0 bottom-0 right-0 left-auto w-[60px] flex flex-row justify-center items-center",
              onMouseenter: showErrorMessage,
              onMouseleave: hideErrorMessage
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "text-red-2 fa-solid fa-circle-info" }, null, -1)
            ]))], 40, _hoisted_8)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "absolute top-0 left-0 right-0 bottom-auto bg-white rounded-md p-2 shadow-md",
              id: 'outer-error_' + _unref(model).key
            }, [
              _createElementVNode("p", {
                class: "font-medium text-sm text-red-2",
                id: 'error_' + _unref(model).key
              }, null, 8, _hoisted_11)
            ], 8, _hoisted_10)
          ], 512), [
            [_vShow, showingErrorMessage.value]
          ])
        ]))
}
}

})